<script setup lang="ts">
/**
 * Thin re-export for Nuxt auto-import of `BaseTitle.vue`.
 * Implementation lives in `@pkg/modular-blocks` (git-moved from this path).
 */
import { TitleBlock as BaseTitle } from '@pkg/modular-blocks/blocks/inner/Title';
</script>

<template>
  <BaseTitle v-bind="$attrs">
    <template v-for="(_, name) in $slots" #[name]="slotData">
      <slot :name="name" v-bind="slotData || {}" />
    </template>
  </BaseTitle>
</template>
